//Rather than use context we are gonna use this class
export default class Auth {
    static isLoggedIn = false;
}



// WEBPACK FOOTER //
// ./src/components/ConnexionContext/Auth.js